/**
 * Hindi (हिंदी) translations
 */
import { TranslationStrings } from '../types';

export const hi: TranslationStrings = {  common: {
    loading: 'लोड हो रहा है...',
    error: 'एक त्रुटि हुई',
    retry: 'पुनः प्रयास करें',
    cancel: 'रद्द करें',
    confirm: 'पुष्टि करें',
    back: 'वापस',
    next: 'आगे',
    submit: 'जमा करें',
    done: 'हो गया',
    close: 'बंद करें',
    yes: 'हाँ',
    no: 'नहीं',
    required: 'आवश्यक',
    optional: 'वैकल्पिक',
  },
  consent: {
    secureConsent: 'सुरक्षित सहमति',
    yourConsentRequired: 'आपकी सहमति आवश्यक है',
    consentingAs: 'के रूप में सहमति दे रहे हैं',
    requestingOrg: 'अनुरोध करने वाला संगठन',
    dataBeingCollected: 'एकत्रित किया जा रहा डेटा',
    purposeOfProcessing: 'प्रसंस्करण का उद्देश्य',
    whatYouWillDo: 'आप क्या करेंगे',
    reviewDocuments: 'दस्तावेज़ों की समीक्षा करें',
    provideConsent: 'सहमति प्रदान करें',
    documentsToRead: 'पढ़ने के लिए दस्तावेज़',
    estimatedTime: 'अनुमानित समय',
    minutes: 'मिनट',
    startReview: 'समीक्षा शुरू करें',
    yourRights: 'DPDP अधिनियम 2023 के तहत आपके अधिकार',
    rightToAccess: 'अपने डेटा तक पहुँचने का अधिकार',
    rightToCorrect: 'अपने डेटा को सुधारने का अधिकार',
    rightToWithdraw: 'सहमति वापस लेने का अधिकार',
    rightToGrievance: 'शिकायत दर्ज करने का अधिकार',
    stepOf: 'चरण {current} / {total}',
    pleaseReadCarefully: 'कृपया सहमति देने से पहले प्रत्येक दस्तावेज़ को ध्यान से पढ़ें।',
    documentsReviewed: 'दस्तावेज़ों की समीक्षा की गई',
    remaining: 'शेष',
    allDocumentsReviewed: 'सभी दस्तावेज़ों की समीक्षा हो गई!',
    clickToRead: 'पढ़ने के लिए नीचे प्रत्येक दस्तावेज़ पर क्लिक करें',
    proceedToConsent: 'आप सहमति प्रदान करने के लिए आगे बढ़ सकते हैं',
    markAsRead: 'पढ़ा हुआ चिह्नित करें',
    continueReading: 'पढ़ना जारी रखें',
    confirmConsent: 'अपनी सहमति की पुष्टि करें',
    selectMethod: 'सत्यापन विधि चुनें',
    iAgreeToTerms: 'मैं सभी नियमों, नीतियों और सहमति समझौतों से सहमत हूँ',
    readAllDocuments: 'मैं समझता/समझती हूं कि मेरी सहमति स्वैच्छिक है और किसी भी समय वापस ली जा सकती है',
    submitConsent: 'सहमति जमा करें',
    submitting: 'जमा हो रहा है...',
    digitalSignature: 'डिजिटल हस्ताक्षर',
    smsVerification: 'SMS सत्यापन',
    emailVerification: 'ईमेल सत्यापन',
    videoRecording: 'वीडियो रिकॉर्डिंग',
    audioRecording: 'ऑडियो रिकॉर्डिंग',
    checkboxConfirmation: 'चेकबॉक्स पुष्टि',
    drawSignature: 'अपना हस्ताक्षर बनाएं',
    verifyViaSms: 'SMS कोड से सत्यापित करें',
    verifyViaEmail: 'ईमेल कोड से सत्यापित करें',
    recordVideoConsent: 'वीडियो सहमति रिकॉर्ड करें',
    recordAudioConsent: 'ऑडियो सहमति रिकॉर्ड करें',
    confirmByChecking: 'चेक करके पुष्टि करें',
    enterOtp: 'OTP दर्ज करें',
    otpSentTo: 'OTP भेजा गया',
    resendOtp: 'OTP पुनः भेजें',
    verifyOtp: 'OTP सत्यापित करें',
    otpVerified: 'OTP सत्यापित',
    invalidOtp: 'अमान्य OTP',
    startRecording: 'रिकॉर्डिंग शुरू करें',
    stopRecording: 'रिकॉर्डिंग बंद करें',
    retake: 'पुनः लें',
    recordingComplete: 'रिकॉर्डिंग पूर्ण',
    consentSubmitted: 'सहमति सफलतापूर्वक जमा की गई',
    thankYou: 'सहमति देने के लिए धन्यवाद',
    confirmationSent: 'आपके ईमेल पर पुष्टि भेज दी गई है',
    referenceNumber: 'संदर्भ संख्या',
    errorSubmitting: 'सहमति जमा करने में विफल। कृपया पुनः प्रयास करें।',
    pleaseReadDocs: 'कृपया पहले सभी दस्तावेज़ पढ़ें',
    pleaseProvideEvidence: 'कृपया सहमति प्रमाण प्रदान करें',
  },
  documents: {
    privacyPolicy: 'गोपनीयता नीति',
    termsOfService: 'सेवा की शर्तें',
    consentAgreement: 'सहमति',
    dataSharingAgreement: 'डेटा साझाकरण समझौता',
    cookiePolicy: 'कुकी नीति',
    retentionPolicy: 'डेटा प्रतिधारण नीति',
    gdprNotice: 'GDPR नोटिस',
    hipaaAuthorization: 'HIPAA प्राधिकरण',
    ccpaDisclosure: 'CCPA प्रकटीकरण',
    aadhaarAuthorization: 'आधार प्राधिकरण',
    customDocument: 'कस्टम दस्तावेज़',
  },
  dataCategories: {
    personalInfo: 'व्यक्तिगत जानकारी',
    contactDetails: 'संपर्क विवरण',
    financialInfo: 'वित्तीय जानकारी',
    healthData: 'स्वास्थ्य और चिकित्सा डेटा',
    biometricData: 'बायोमेट्रिक डेटा',
    locationData: 'स्थान डेटा',
    behavioralData: 'व्यवहार डेटा',
    communicationData: 'संचार डेटा',
    employmentInfo: 'रोजगार जानकारी',
    educationInfo: 'शैक्षिक जानकारी',
  },
  a11y: {
    mainContent: 'मुख्य सामग्री',
    navigation: 'नेविगेशन',
    closeModal: 'मोडल बंद करें',
    expandSection: 'अनुभाग विस्तारित करें',
    collapseSection: 'अनुभाग संकुचित करें',
    documentRead: 'दस्तावेज़ पढ़ा हुआ चिह्नित',
    documentUnread: 'दस्तावेज़ अभी तक नहीं पढ़ा गया',
    progressIndicator: 'प्रगति: {current} / {total} दस्तावेज़ पढ़े गए',
    signaturePad: 'हस्ताक्षर क्षेत्र',
    clearSignature: 'हस्ताक्षर साफ़ करें',
    videoPlayer: 'वीडियो रिकॉर्डिंग प्लेयर',
    audioPlayer: 'ऑडियो रिकॉर्डिंग प्लेयर',
    requiredField: 'यह फ़ील्ड आवश्यक है',
    errorMessage: 'त्रुटि',
    successMessage: 'सफलता',
    loadingContent: 'सामग्री लोड हो रही है, कृपया प्रतीक्षा करें',
    newWindow: 'नई विंडो में खुलता है',
  },
  portal: {
    // General
    myConsents: 'मेरी सहमतियाँ',
    viewManageConsents: 'अपनी सहमति रिकॉर्ड देखें और प्रबंधित करें',
    logout: 'लॉग आउट',
    welcomeBack: 'वापसी पर स्वागत है',
    
    // Tenant selector
    organizationNameOrCode: 'संगठन का नाम या कोड',
    orgPlaceholder: 'उदा., globalhealth या acme-corp',
    orgHint: 'अपने संगठन द्वारा दिया गया नाम या कोड दर्ज करें',
    findMyOrganization: 'मेरा संगठन खोजें',
    orgNotFound: 'संगठन नहीं मिला। कृपया नाम जाँचें और पुनः प्रयास करें।',
    enterOrgName: 'कृपया अपने संगठन का नाम या कोड दर्ज करें',
    or: 'या',
    haveDirectLink: 'क्या आपके पास संगठन से सीधा लिंक है?',
    useDirectLink: 'उनके द्वारा दिए गए लिंक का उपयोग करें',
    privacyProtected: 'आपकी गोपनीयता कानून द्वारा सुरक्षित है',
    
    // Login flow
    phoneOrEmail: 'फ़ोन नंबर या ईमेल',
    enterPhoneOrEmailPlaceholder: 'अपना पंजीकृत फ़ोन या ईमेल दर्ज करें',
    otpWillBeSent: 'हम आपको एक वन-टाइम पासवर्ड (OTP) भेजेंगे',
    sendOtp: 'OTP भेजें',
    enterPhoneOrEmail: 'कृपया अपना फ़ोन नंबर या ईमेल दर्ज करें',
    otpSentTo: 'OTP भेजा गया',
    expiresIn: 'समाप्ति',
    enterOtp: 'OTP दर्ज करें',
    enterValidOtp: 'कृपया वैध OTP दर्ज करें',
    verifyOtp: 'OTP सत्यापित करें',
    resendOtp: 'OTP पुनः भेजें',
    otpVerified: 'OTP सत्यापित',
    oneMoreStep: 'आपकी पहचान सत्यापित करने के लिए एक और कदम',
    enterSecurityAnswer: 'कृपया अपना उत्तर दर्ज करें',
    enterAnswer: 'अपना उत्तर दर्ज करें',
    dobFormat: 'प्रारूप: DDMMYYYY (उदा., 15051990 for 15 मई, 1990)',
    login: 'लॉग इन',
    startOver: 'फिर से शुरू करें',
    needHelp: 'मदद चाहिए?',
    privacyNotice: 'आपका डेटा लागू गोपनीयता कानूनों के तहत सुरक्षित है',
    checkUrlOrContact: 'कृपया URL जाँचें या अपने संगठन से संपर्क करें।',
    
    // Consent history
    filterAll: 'सभी',
    statusActive: 'सक्रिय',
    statusWithdrawn: 'वापस लिया गया',
    statusExpired: 'समाप्त',
    noConsents: 'कोई सहमति रिकॉर्ड नहीं मिला',
    noConsentsWithFilter: 'इस स्थिति वाली कोई सहमति नहीं',
    consentedOn: 'सहमति दी',
    expiresOn: 'समाप्त होगी',
    withdrawnOn: 'वापस लिया गया',
    withdrawConsent: 'सहमति वापस लें',
    withdrawalHistory: 'वापसी इतिहास',
    help: 'सहायता',
    
    // Withdrawal
    cannotWithdraw: 'यह सहमति वापस नहीं ली जा सकती',
    pleaseConfirmWithdrawal: 'कृपया पुष्टि करें कि आप परिणाम समझते हैं',
    importantNotice: 'महत्वपूर्ण सूचना',
    withdrawalNotice1: 'संगठन बताए गए उद्देश्यों के लिए आपके डेटा को संसाधित करना बंद कर देगा।',
    withdrawalNotice2: 'कुछ डेटा कानूनी अनुपालन के लिए रखा जा सकता है।',
    withdrawalNotice3: 'कुछ सेवाओं का उपयोग करने के लिए आपको फिर से सहमति देनी पड़ सकती है।',
    withdrawalNotice4: 'प्रसंस्करण समय लागू कानूनों के आधार पर 7-30 दिन लग सकते हैं।',
    withdrawalReason: 'वापसी का कारण',
    withdrawalReasonPlaceholder: 'हमें बताएं कि आप क्यों वापस लेना चाहते हैं (वैकल्पिक)',
    withdrawalConfirmation: 'मैं समझता/समझती हूं कि मेरी सहमति वापस लेने से कुछ सेवाओं का उपयोग प्रभावित हो सकता है, और मैं इस अनुरोध के साथ आगे बढ़ना चाहता/चाहती हूं।',
    submitWithdrawalRequest: 'वापसी अनुरोध जमा करें',
    withdrawalSubmitted: 'वापसी अनुरोध जमा किया गया',
    withdrawalSubmittedDesc: 'आपका वापसी अनुरोध जमा कर दिया गया है। संगठन द्वारा संसाधित होने पर आपको सूचित किया जाएगा।',
    processingTime: 'प्रसंस्करण समय',
    days: 'दिन',
    backToHistory: 'सहमति इतिहास पर वापस जाएं',
    
    // Withdrawal history
    statusPending: 'लंबित',
    statusApproved: 'स्वीकृत',
    statusRejected: 'अस्वीकृत',
    noWithdrawals: 'अभी तक कोई वापसी अनुरोध नहीं',
    viewConsents: 'अपनी सहमतियाँ देखें',
    requestedOn: 'अनुरोध किया गया',
    processedOn: 'संसाधित किया गया',
    processingMessage: 'आपका अनुरोध संसाधित किया जा रहा है। पूरा होने पर आपको सूचित किया जाएगा।',
    processingTimeInfo: 'प्रसंस्करण समय जानकारी',
    
    // Help section
    yourRights: 'आपके गोपनीयता अधिकार',
    helpTitle: 'अपने गोपनीयता अधिकारों को समझें',
    helpSubtitle: 'गोपनीयता कानूनों के तहत अपने अधिकारों और सहमति प्रबंधन के बारे में जानें।',
    quickActions: 'त्वरित कार्रवाई',
    viewMyConsents: 'मेरी सहमतियाँ देखें',
    viewWithdrawalRequests: 'वापसी अनुरोध देखें',
    loginToViewConsents: 'अपनी सहमतियाँ देखने के लिए लॉग इन करें',
    applicableLaws: 'लागू गोपनीयता कानून',
    
    // Rights FAQ
    rightAccessQ: 'एक्सेस का अधिकार क्या है?',
    rightAccessA: 'आपको यह जानने का अधिकार है कि आपके बारे में कौन सा व्यक्तिगत डेटा एकत्र किया जा रहा है, इसका उपयोग कैसे किया जा रहा है, और इसे किसके साथ साझा किया जा रहा है।',
    rightCorrectQ: 'सुधार का अधिकार क्या है?',
    rightCorrectA: 'यदि आपका व्यक्तिगत डेटा गलत या अपूर्ण है, तो आप इसे सही या अपडेट करने का अनुरोध कर सकते हैं।',
    rightWithdrawQ: 'सहमति वापस लेने का अधिकार क्या है?',
    rightWithdrawA: 'आप किसी भी समय अपनी सहमति वापस ले सकते हैं। वापसी के बाद, संगठन को उन उद्देश्यों के लिए आपके डेटा को संसाधित करना बंद करना होगा।',
    rightEraseQ: 'मिटाने का अधिकार क्या है?',
    rightEraseA: '"भूल जाने का अधिकार" के रूप में भी जाना जाता है, आप अनुरोध कर सकते हैं कि आपका व्यक्तिगत डेटा हटा दिया जाए।',
    
    // Withdrawal FAQ
    withdrawalFaq: 'वापसी प्रक्रिया',
    withdrawHowQ: 'मैं अपनी सहमति कैसे वापस लूं?',
    withdrawHowA: 'अपने खाते में लॉग इन करें, अपने सहमति इतिहास पर जाएं, और किसी भी सक्रिय सहमति पर "सहमति वापस लें" पर क्लिक करें।',
    withdrawTimeQ: 'वापसी में कितना समय लगता है?',
    withdrawTimeA: 'प्रसंस्करण समय लागू कानूनों पर निर्भर करता है: DPDP अधिनियम (भारत) - 7 दिन, GDPR (EU) - 30 दिन, CCPA (कैलिफ़ोर्निया) - 45 दिन।',
    withdrawEffectQ: 'सहमति वापस लेने के बाद क्या होता है?',
    withdrawEffectA: 'संगठन बताए गए उद्देश्यों के लिए आपके डेटा का उपयोग बंद कर देगा। कुछ डेटा कानूनी अनुपालन के लिए रखा जा सकता है।',
    
    // Security FAQ
    securityFaq: 'खाता सुरक्षा',
    loginSecureQ: 'मेरा लॉगिन कैसे सुरक्षित है?',
    loginSecureA: 'हम 3-चरणीय सत्यापन प्रक्रिया का उपयोग करते हैं: आपके पंजीकृत फ़ोन/ईमेल पर OTP, उसके बाद एक सुरक्षा प्रश्न।',
    dataProtectQ: 'मेरा डेटा कैसे सुरक्षित है?',
    dataProtectA: 'सभी डेटा ट्रांज़िट और रेस्ट में एन्क्रिप्टेड है। हम DPDP अधिनियम, GDPR और अन्य लागू गोपनीयता नियमों का पालन करते हैं।',
    
    // Contact FAQ
    contactFaq: 'संपर्क और सहायता',
    grievanceQ: 'मैं शिकायत कैसे दर्ज करूं?',
    grievanceA: 'आप संगठन के डेटा सुरक्षा अधिकारी (DPO) या शिकायत अधिकारी से संपर्क कर सकते हैं।',
    regulatorQ: 'नियामक प्राधिकरण कौन है?',
    regulatorA: 'भारत में, डेटा सुरक्षा बोर्ड गोपनीयता शिकायतों को संभालता है। EU में, आप अपने राष्ट्रीय डेटा सुरक्षा प्राधिकरण से संपर्क कर सकते हैं।',
  },
}
;
